<template>
  <SubRegistro :classe="classe">
    <Cabecalho
      tipo="porcentagem2"
      v-if="!registroSelecionado.blSimplesNacional"
      :titulo="alteracaoImportacao ? 'PIS - Importação' : 'PIS'"
      :aliquota="registroSelecionado.aliquota_pis"
    />
    <Cabecalho
      tipo="porcentagem5"
      v-if="registroSelecionado.blSimplesNacional"
      :titulo="registroSelecionado.label_pis"
      :aliquota="registroSelecionado.aliquota_pis"
    />

    <div v-if="registroSelecionado.aliquota_pis" class="separador" />

    <Cabecalho
      tipo="porcentagem2"
      v-if="registroSelecionado.red_aliquota_pis"
      :titulo="
        `Redução da Base de Cálculo ${
          registroSelecionado.tipo_red_pis ? registroSelecionado.tipo_red_pis : ''
        }`
      "
      :aliquota="registroSelecionado.red_aliquota_pis"
    />
    <div v-if="registroSelecionado.red_aliquota_pis" class="separador" />
    <Cabecalho
      tipo="porcentagem2"
      v-if="registroSelecionado.red_aliquota_outra_pis"
      :titulo="
        `Redução da Base de Cálculo ${
          registroSelecionado.tipo_red_pis ? registroSelecionado.tipo_red_pis : ''
        }`
      "
      :aliquota="registroSelecionado.red_aliquota_outra_pis"
    />
    <div v-if="registroSelecionado.red_aliquota_outra_pis" class="separador" />

    <Memoria :titulo="'Memória de cálculo:'" :memoria="registroSelecionado.memoria_pis" />
    <Memoria negrito v-if="registroSelecionado.red_aliquota_pis" :memoria="this.baseDeCalculoPis" />

    <div v-if="registroSelecionado.red_aliquota_pis" class="separador" />

    <Cabecalho
      v-if="!!registroSelecionado.adicional_aliquota_pis"
      :titulo="'Adicional de Alíquota'"
      :aliquota="registroSelecionado.adicional_aliquota_pis"
    />
    <div
      v-if="
        (registroSelecionado.adicional_aliquota_pis ||
          registroSelecionado.aliquota_efetiva_pis ||
          registroSelecionado.label_pis) &&
          registroSelecionado.label_pis_excedente
      "
      class="separador"
    />
    <Cabecalho
      v-if="!!registroSelecionado.aliquota_efetiva_pis"
      :titulo="'Alíquota Efetiva'"
      :aliquota="registroSelecionado.aliquota_efetiva_pis"
    />
    <div
      v-if="!!registroSelecionado.aliquota_efetiva_pis && registroSelecionado.aliquota_pis"
      class="separador"
    />

    <Cabecalho
      tipo="porcentagem5"
      v-if="registroSelecionado.label_pis_excedente"
      :titulo="registroSelecionado.label_pis_excedente"
      :aliquota="registroSelecionado.aliquota_pis_excedente"
    />
    <div v-if="registroSelecionado.label_pis_excedente" class="separador" />
    <Memoria :titulo="'Memória de cálculo:'" :memoria="registroSelecionado.memoria_pis_excedente" />

    <BaseLegal
      :modificador="' do Adicional de Alíquota'"
      :base_legal="registroSelecionado.base_legal_adicional_pis"
      :classe="classe"
    />
    <BaseLegal :base_legal="registroSelecionado.base_legal_pis" :classe="classe" />
  </SubRegistro>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
import Separador from "@/components/Fields/Separador/Separador.vue";
import SubRegistro from "@/components/SubRegistro/SubRegistro.vue";
import Memoria from "../Memoria/Memoria.vue";

export default {
  name: "RegistroPis",
  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    EditButton,
    Notificacao,
    RadioButton,
    Registro,
    Separador,
    SubRegistro,
    Ncm,
    Memoria
  },
  props: { registroSelecionado: Object, classe: String },
  inject: ["alteracaoImportacao"],
  data() {
    return {
      baseDeCalculoPis:
        "(Receita Bruta - % de Redução de Base de Cálculo) = Base de Cálculo <br> Base de Cálculo x Alíquota do PIS = Valor do PIS <br> (Valor do PIS / Receita Bruta) x 100 = Alíquota Efetiva do PIS"
    };
  }
};
</script>

<style lang="scss" scoped></style>
